import React, { FC } from "react";
import { IconType } from "./types";

export const FaceHappyIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2627_7484)">
      <path
        d="M12.5 7.5H12.5083M7.49996 7.5H7.50829M18.3333 10C18.3333 14.6024 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6024 1.66663 10C1.66663 5.39763 5.39759 1.66667 9.99996 1.66667C14.6023 1.66667 18.3333 5.39763 18.3333 10ZM12.9166 7.5C12.9166 7.73012 12.7301 7.91667 12.5 7.91667C12.2698 7.91667 12.0833 7.73012 12.0833 7.5C12.0833 7.26989 12.2698 7.08334 12.5 7.08334C12.7301 7.08334 12.9166 7.26989 12.9166 7.5ZM7.91663 7.5C7.91663 7.73012 7.73008 7.91667 7.49996 7.91667C7.26984 7.91667 7.08329 7.73012 7.08329 7.5C7.08329 7.26989 7.26984 7.08334 7.49996 7.08334C7.73008 7.08334 7.91663 7.26989 7.91663 7.5ZM9.99996 14.5833C12.0837 14.5833 13.75 13.0558 13.75 11.6667H6.24996C6.24996 13.0558 7.91621 14.5833 9.99996 14.5833Z"
        stroke="#BBBBBB"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2627_7484">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
